module.exports = __webpack_public_path__ + "static/media/cloud-upload.a5e63275.svg";